<template>
  <div class="info-box-card" v-if="!isNullObj">
    <p class="info-title">{{ title }}</p>
    <div class="info-data">
      <div v-for="(val, key, idx) in infoData" :key="idx" class="data-box">
        <p class="name">{{ key }}</p>
        <div class="value">
          <el-table
            :data="val"
            :show-header="false"
            border
            :cell-style="columnStyle"
            style="width: 100%"
          >
            <el-table-column
              property="baseDataItemNameShow"
              label="baseDataItemNameShow"
              align="left"
              min-width="33%"
              show-overflow-tooltip
            >
            <template slot-scope="scope">
              <span style="display: inline-block; width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.baseDataItemNameShow}}</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="baseDataValue"
              label="baseDataValue"
              align="left"
              min-width="67%"
              show-overflow-tooltip
            >
              <template slot-scope="props">
                <span style="display: inline-block; width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                <el-my-popover
                  slot="reference"
                  :item="formatItem(props.row)"
                  :value="props.row.baseDataValue + props.row.unit"
                ></el-my-popover>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elMyPopover from "./elMyPopover.vue";
export default {
  components: {
    elMyPopover,
  },
  props: {
    title: {
      type: String,
      default: "健康监测",
    },
    infoData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isNullObj() {
      if (JSON.stringify(this.infoData) == "{}") {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {

    };
  },
  methods: {
    formatItem(item) {
      return {
        dataItem: item.baseDataItem,
        dataItemCode: item.baseDataItemCode,
      };
    },
    columnStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "background: #f2f2f2";
      }
      // if (columnIndex == 1) {
      //   return "width: 54%";
      // }
    },
  },
};
</script>
<style lang="scss">
// .hover-poppover {
//   background: #000;
//   color: #fff;
//   border: none;
//   .popper__arrow::after {
//   border-top-color: #000!important;
//   border-bottom-color: #000 !important
// }
// }
.info-box-card {
  .cell {
    display: flex;
    align-items: center;
  }
  .el-table::before {
    height: 0;
  }
  .el-table__body-wrapper th,
  .el-table__body-wrapper tr {
    background-color: transparent;
    // color: rgba(255, 255, 255, 1);
    opacity: 0.8;
    border: none;
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background: transparent;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background: rgba(255, 255, 255, 0.3);
  }
  .el-table {
    border-radius: 2px;
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";
  .el-tooltip {
    display: flex;
    align-items: center;
  }
.info-box-card {
  margin: 32px 24px 0 0;
  // margin-bottom: 20px;
  .info-title {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    padding-left: 20px;
    position: relative;
    &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 8px;
        background-color: $theme;
    }
  }
  .info-data {
    margin: 16px 0 0 0;
    position: relative;
    // background: rgba(255, 255, 255, 0.06);
    // padding: 28px 0 12px;
    display: flex;
    flex-wrap: wrap;
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      content: "";
      width: 199px;
      height: 100%;
      z-index: 1;
    }
    .data-box {
      z-index: 2;
      box-sizing: border-box;
      display: flex;
      flex-grow: 0;
      width: 50%;
      padding: 10px;
      margin-bottom: 16px;
      padding-right: 98px;
      // overflow: hidden;
      &:nth-child(2n-1) {
        padding-left: 20px;
      }
      &:nth-child(2n) {
        padding-left: 8px;
      }
      .name {
        width: 56px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        // font-weight: 500;
        // color: #ffffff;
        line-height: 20px;
        text-align: justify;
        text-justify: distribute-all-lines; /*ie6-8*/
        text-align-last: justify; /* ie9*/
        -moz-text-align-last: justify; /*ff*/
        -webkit-text-align-last: justify; /*chrome 20+*/
      }
      .value {
        margin-left: 14px;
        flex: 1;
        text-align: left;
        overflow: hidden;
        // flex-grow: 0;
        // flex-shrink: 0;
      }
    }
  }
}
</style>
